export default "__VITE_ASSET__qw6hE4H4__"